import { Routes } from './routes';

export interface BreadcrumbsProps {
  id: number;
  path: string;
  title: string;
  icon?: React.JSX.Element;
}

export interface IRoute {
  title: string;
  icon?: React.JSX.Element;
}

export type ItemRender = (
  route: IRoute,
  params: Record<string, any>,
  routes: IRoute[],
  paths: string[]
) => React.JSX.Element;

export const guidePage: BreadcrumbsProps[] = [
  {
    id: 0,
    path: '/',
    title: 'Home',
  },
  {
    id: 1,
    path: '/guides',
    title: 'Guides',
  },
];

export const blogPage: BreadcrumbsProps[] = [
  {
    id: 0,
    path: '/',
    title: 'Home',
  },
  {
    id: 1,
    path: '/blog-and-news',
    title: 'Blog & news',
  },
];

export const guidesPage: BreadcrumbsProps[] = [
  {
    id: 0,
    path: '/',
    title: 'Home',
  },
  {
    id: 1,
    path: '/guides',
    title: 'Guides',
  },
];

export const blogAndNewsPage: BreadcrumbsProps[] = [
  {
    id: 0,
    path: '/',
    title: 'Home',
  },
  {
    id: 1,
    path: '/blog-and-news',
    title: 'Blog & news',
  },
];

export const blogsPage: BreadcrumbsProps[] = [
  {
    id: 0,
    path: '/',
    title: 'Home',
  },
  {
    id: 1,
    path: '/guides',
    title: 'Guides',
  },
];

export const casinoPage: BreadcrumbsProps[] = [
  {
    id: 0,
    path: '/',
    title: 'Home',
  },
  {
    id: 1,
    path: '/casinos',
    title: 'All Casinos',
  },
];

export const streamerPage: BreadcrumbsProps[] = [
  {
    id: 0,
    path: '/',
    title: 'Home',
  },
  {
    id: 1,
    path: '/streamers',
    title: 'Streamers',
  },
];

export const slotPage: BreadcrumbsProps[] = [
  {
    id: 0,
    path: '/',
    title: 'Home',
  },
  {
    id: 1,
    path: '/slots',
    title: 'All Slots',
  },
];

export const reviewsSlot: BreadcrumbsProps[] = [
  {
    id: 0,
    path: '/',
    title: 'Home',
  },
  {
    id: 1,
    path: '/slots',
    title: 'Slot reviews',
  },
];

export const reviewsCasino: BreadcrumbsProps[] = [
  {
    id: 0,
    path: '/',
    title: 'Home',
  },
  {
    id: 1,
    path: '/casinos',
    title: 'All Casinos',
  },
];

export const allSlots: BreadcrumbsProps[] = [
  {
    id: 0,
    path: '/',
    title: 'Home',
  },
  {
    id: 1,
    path: '/slots',
    title: 'All Slots',
  },
];

export const allCasinos: BreadcrumbsProps[] = [
  {
    id: 0,
    path: '/',
    title: 'Home',
  },
  {
    id: 1,
    path: '/casinos',
    title: 'All Casinos',
  },
];

export const allCasinosCollections: BreadcrumbsProps[] = [
  {
    id: 0,
    path: '/',
    title: 'Home',
  },
  {
    id: 1,
    path: '/casinos',
    title: 'Casinos',
  },
  {
    id: 1,
    path: '/casinos/collections',
    title: 'All Collections',
  },
];

export const allBigwins: BreadcrumbsProps[] = [
  {
    id: 0,
    path: '/',
    title: 'Home',
  },
  {
    id: 1,
    title: 'All Bigwins',
    path: Routes?.bigwins,
  },
];

export const allBlogs: BreadcrumbsProps[] = [
  {
    id: 0,
    path: '/',
    title: 'Home',
  },
  {
    id: 1,
    path: '/blogs/all',
    title: 'All Blogs',
  },
];

export const aboutUs: BreadcrumbsProps[] = [
  {
    id: 0,
    path: '/',
    title: 'Home',
  },
  {
    id: 1,
    title: 'About RTPcheck.com',
    path: Routes?.aboutUs,
  },
];

export const home: BreadcrumbsProps[] = [
  {
    id: 0,
    path: '/',
    title: 'Home',
  },
];

export const complaints: BreadcrumbsProps[] = [
  {
    id: 0,
    path: '/',
    title: 'Home',
  },
  { id: 1, path: `/casino-complaints/`, title: 'Casino Complaints' },
];

export const questions: BreadcrumbsProps[] = [
  {
    id: 0,
    path: '/',
    title: 'Home',
  },
  { id: 1, path: `/questions/`, title: 'Topics' },
];

export const publication: BreadcrumbsProps[] = [
  {
    id: 0,
    path: '/',
    title: 'Home',
  },
  { id: 1, path: `/publication/`, title: 'Publication' },
];

export const providers: BreadcrumbsProps[] = [
  {
    id: 0,
    path: Routes.home,
    title: 'Home',
  },
  {
    id: 1,
    path: Routes.allSlots,
    title: 'Slots',
  },
  {
    id: 2,
    path: Routes.providers,
    title: 'Providers',
  },
];

export const search: BreadcrumbsProps[] = [
  {
    id: 0,
    path: Routes.home,
    title: 'Home',
  },
  {
    id: 1,
    path: Routes.search,
    title: 'Search',
  },
];
